import type { QueryKey } from '@tanstack/react-query';

import { useQuery } from '../../../ReactQuery';
import { post } from '../../../redux/api';
import type { Policy } from '../../../types';

const postPolicy = (policy: Policy) => {
  return post<Policy, Policy>(`/api/policies/`, policy);
};

const getQueryKeyForPolicy = (policy: Policy): QueryKey => ['policy', policy.toString()];

/**
 * hook for creating one policy
 */
export default function useUpdatePolicy(policy: Policy) {
  return useQuery<Policy>({
    queryKey: getQueryKeyForPolicy(policy),
    queryFn: () => postPolicy(policy),
  });
}
